module.exports = {
  API_BASE_URL: "/api",
  // 后台接口与素材统一走线上后端；可用 VUE_APP_BACKEND_ORIGIN 临时覆盖。
  BACKEND_ORIGIN:
    process.env.VUE_APP_BACKEND_ORIGIN || "https://md.ddcloudrack.com:9999",

  // 历史上传文件不在本地时，图片地址回退到现有素材服务。
  PUBLIC_ASSET_ORIGIN:
    process.env.VUE_APP_PUBLIC_ASSET_ORIGIN || "https://md.ddcloudrack.com:9999",

  // 本地开发服务器也代理到线上后端。
  LOCAL_BACKEND_ORIGIN:
    process.env.LOCAL_BACKEND_ORIGIN || "https://md.ddcloudrack.com:9999",

  // 爬宠商城后端：后台的「平台客服」页面直连它读写买家会话（与爬宠后端是两套系统）。
  // 本地联调用 http://127.0.0.1:4100，正式环境改成商城后端对外地址。
  SHOP_API_ORIGIN: process.env.SHOP_API_ORIGIN || "http://127.0.0.1:4100",
  // 商城后端里绑定虚拟店铺 platform-service 的平台客服账号（仅内部后台使用）。
  SHOP_SERVICE_ACCOUNT: {
    username: process.env.SHOP_SERVICE_USERNAME || "platform",
    password: process.env.SHOP_SERVICE_PASSWORD || "pachong888"
  }
}
